import { useTranslation } from "react-i18next";

import { useOptionalTaskRuntime } from "../../../context/TaskRuntimeContext";

export default function useOSRBOITranslator() {
  const { t } = useTranslation();
  const runtime = useOptionalTaskRuntime();

  return runtime?.programScopedLocale?.programT || t;
}
